import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import commonFR from './locales/fr/common.json';
import commonEN from './locales/en/common.json';
import authFR from './locales/fr/auth.json';
import authEN from './locales/en/auth.json';
import dashboardFR from './locales/fr/dashboard.json';
import dashboardEN from './locales/en/dashboard.json';
import onboardingFR from './locales/fr/onboarding.json';
import onboardingEN from './locales/en/onboarding.json';
import workoutFR from './locales/fr/workout.json';
import workoutEN from './locales/en/workout.json';

const cached = localStorage.getItem('kaiyloLanguage');
const detected = navigator.language?.startsWith('en') ? 'en' : 'fr';
const initialLng = (cached === 'fr' || cached === 'en') ? cached : detected;

i18n
  .use(initReactI18next)
  .init({
    lng: initialLng,
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en'],
    defaultNS: 'common',
    ns: ['common', 'auth', 'dashboard', 'onboarding', 'workout'],
    resources: {
      fr: {
        common: commonFR,
        auth: authFR,
        dashboard: dashboardFR,
        onboarding: onboardingFR,
        workout: workoutFR,
      },
      en: {
        common: commonEN,
        auth: authEN,
        dashboard: dashboardEN,
        onboarding: onboardingEN,
        workout: workoutEN,
      },
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    saveMissing: import.meta.env.DEV,
    missingKeyHandler: import.meta.env.DEV
      ? (lngs, ns, key) => {
          // Only warn when the ACTIVE language is missing the key.
          if (lngs[0] !== i18n.language) return;
          console.warn(`[i18n] missing ${lngs[0]}:${ns}:${key}`);
        }
      : undefined,
    initImmediate: false,
  });

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});
document.documentElement.lang = i18n.language;

export default i18n;
